export const createDefaults = {
  name: '',
  email: '',
  phone: '',
  status: true,
  password: '',
  password_confirmation: '',
  scopes: [],
  role: '',
};
